import { SERVICE_URL } from './ServiceURL'

class UserService {

	constructor(resource) {
		this.store = resource.$store;
		this.http = resource.$http;
  }

  registerAccess(data) {
    this.http.post(`${SERVICE_URL}v1/user/logoperational`, data)
    .then(result => {
      return result.status === 201
    })
  }

  getUsersAudity( ){
    return new Promise((resolve, reject) => {
      this.http.get(`${SERVICE_URL}v1/user/auditors`, {
        headers: {
          'x-access-token': this.store.state.user.token || ''
        }
      })
        .then(response => response.json())
        .then(plans => resolve(plans))
        .catch(err => {
          reject(err.body.message || err.message)
        })
    })
  }

	doLogin(user, password) {
		return new Promise((resolve, reject) => {
			let authorization = new Buffer(`${user}:${password}`).toString("base64");

			this.http.post(`${SERVICE_URL}v1/user/auth`, null, {
				headers: {
					'Authorization': `Basic ${authorization}`
				}
			})
			.then(result => result.json())
			.then(user => {

        this.registerAccess({
          pabx: user.pabx,
          matricula: user.matricula,
          campanhaId: user.campanhaId,
          equipeId: user.equipeId,
          usuarioId: user.id
        })

				this.store.commit("setUser", user);
				resolve(user);
			})
			.catch(err =>{
				console.log('SERVICE ERROR', err);
				reject(err.body.message || err.message);
			})
		});
	}
}
export default UserService;



// WEBPACK FOOTER //
// ./src/service/UserService.js